<template>
    <v-container class="mb-6">

        <v-breadcrumbs :items="breadcrumbs"></v-breadcrumbs>

        <v-card class="elevation-2 mt-5 mb-8">
            <v-card-title class="flex-nowrap">
                Filtros
            </v-card-title>
            <v-card-text>
                <form @submit.prevent="processSearch">
                    <v-row align="center">
                        <v-col cols="12" sm="6">
                            <v-menu
                                ref="menuInit"
                                v-model="menuInit"
                                :close-on-content-click="false"
                                :return-value.sync="dateInit"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dateInit"
                                    label="Fecha inicial"
                                    prepend-inner-icon="mdi-calendar"
                                    outlined
                                    dense
                                    hide-details
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="dateInit"
                                    no-title
                                    scrollable
                                    locale="es"
                                    color="primary"
                                    class="ma-0"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="red"
                                        @click="menuInit = false"
                                    >
                                        Cancelar
                                    </v-btn>
                                    <v-btn
                                        color="primary"
                                        @click="$refs.menuInit.save(dateInit)"
                                    >
                                        Aceptar
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-menu
                                ref="menuEnd"
                                v-model="menuEnd"
                                :close-on-content-click="false"
                                :return-value.sync="dateEnd"
                                transition="scale-transition"
                                offset-y
                                min-width="auto"
                            >
                                <template v-slot:activator="{ on, attrs }">
                                <v-text-field
                                    v-model="dateEnd"
                                    label="Fecha final"
                                    prepend-inner-icon="mdi-calendar"
                                    outlined
                                    dense
                                    hide-details
                                    v-bind="attrs"
                                    v-on="on"
                                ></v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="dateEnd"
                                    no-title
                                    scrollable
                                    locale="es"
                                    color="primary"
                                    class="ma-0"
                                >
                                    <v-spacer></v-spacer>
                                    <v-btn
                                        text
                                        color="red"
                                        @click="menuEnd = false"
                                    >
                                        Cancelar
                                    </v-btn>
                                    <v-btn
                                        color="primary"
                                        @click="$refs.menuEnd.save(dateEnd)"
                                    >
                                        Aceptar
                                    </v-btn>
                                </v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col cols="12" sm="6">
                            <v-select
                                v-model="seeIn"
                                :items="[{val:'cantidad', text:'Cantidad'}, {val:'valorado', text:`Valorado ${money}`}]"
                                label="Ver en"
                                item-value="val"
                                item-text="text"
                                outlined
                                dense
                                hide-details
                            ></v-select>
                        </v-col>
                    </v-row>
                    <div class="text-right mt-8">
                        <v-btn
                            class="text-capitalize mb-2 mb-sm-0 mr-2"
                            :href="`/admin/suplies/download?date_init=${dateInit}&date_end=${dateEnd}`"
                        >
                            <v-icon class="mr-2" color="green">mdi-file-excel</v-icon>
                            Exportar
                        </v-btn>

                        <v-btn
                            color="primary"
                            type="submit"
                        >
                            Buscar
                        </v-btn>
                        <v-btn
                            color="red"
                            text
                            v-show="(dateInit!='') || (dateEnd!='')"
                            @click="cleanSearch('')"
                        >
                            Limpiar
                        </v-btn>
                    </div>
                </form>
            </v-card-text>
        </v-card>

        <!-- card main -->
        <v-card class="elevation-2 mt-5">
            <v-card-title class="blue-grey darken-4 white--text">
                Inventario
                <v-spacer></v-spacer>
                <v-btn
                    @click="uploadSupliesDialog = true"
                    class="text-capitalize mr-2"
                >
                    <v-icon class="mr-2" color="green">mdi-file-table</v-icon>
                    Cargar Excel
                </v-btn>
                <v-btn
                    color="primary"
                    @click="newSuply"
                    class="mr-2"
                >Nuevo Insumo</v-btn>

                <v-btn
                    color="primary"
                    @click="dialogStock = !dialogStock; listProduct=listProduct.map(sup => ({...sup, quantity:0, cost: 0})); calculateTotal();"
                >Agregar stock</v-btn>
            </v-card-title>

            <v-simple-table>
                <template v-slot:default>
                <thead>
                    <tr v-if="seeIn=='valorado' && !overlay" class="bg-grey lighten-2">
                        <td colspan="2">
                            <v-chip
                                color="primary"
                                outlined
                            >
                                <strong>TOTAL</strong>
                            </v-chip>
                        </td>
                        <td></td>
                        <td></td>
                        <td class="text-right"><strong>{{ formatNumber(sumaTotal('initial')) }}</strong></td>
                        <td class="text-right"><strong>{{ formatNumber(sumaTotal('buys')) }}</strong></td>
                        <td class="text-right"><strong>-{{ formatNumber(sumaTotal('outcome')) }}</strong></td>
                        <td class="text-right"><strong>{{ formatNumber(sumaTotal('final')) }}</strong></td>
                    </tr>
                    <tr>
                        <th>·</th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Código</span>
                                <div class="wrap-order" v-if="tmpType=='all'">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='code', getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='code', getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="CodeInsumo"
                                                    label="Código"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('product')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Insumo</span>
                                <div class="wrap-order" v-if="tmpType=='all'">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy='name', getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy='name', getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtInsumo"
                                                    label="Insumo"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="text"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('product')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu>
                            </div>
                        </th>

                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span v-if="seeIn=='cantidad'">Medida</span>
                                <span v-if="seeIn=='valorado'">Moneda</span>
                                <!-- <v-menu offset-y :close-on-content-click="false">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <v-select
                                                v-model="seeIn"
                                                :items="[{val:'cantidad', text:'Cantidad'}, {val:'valorado', text:`Valorado ${money}`}]"
                                                label="Ver en"
                                                item-value="val"
                                                item-text="text"
                                                outlined
                                                dense
                                                hide-details
                                            ></v-select>
                                        </v-card-text>
                                    </v-card>
                                </v-menu> -->
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>Stock Inicial</span>
                                <!-- <div class="wrap-order" v-if="tmpType=='all'">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy=`${seeIn=='cantidad' ? 'inv_init' : 'pro_init'}`, getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy=`${seeIn=='cantidad' ? 'inv_init' : 'pro_init'}`, getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false" v-if="tmpType=='all'">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtStockInit"
                                                    label="Stock Inicial"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="nuimber"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('stock_init')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu> -->
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>(+) Compras</span>
                                <!-- <div class="wrap-order" v-if="tmpType=='all'">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy=`${seeIn=='cantidad' ? 'qty_input' : 'pro_input'}`, getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy=`${seeIn=='cantidad' ? 'qty_input' : 'pro_input'}`, getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false" v-if="tmpType=='all'">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtCompras"
                                                    label="Compras"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="number"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('compras')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu> -->
                            </div>
                        </th>
                        <th class="text-left">
                            <div class="d-flex align-center">
                                <span>(-) Salidas</span>
                                <!-- <div class="wrap-order" v-if="tmpType=='all'">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy=`${seeIn=='cantidad' ? 'qty_output' : 'pro_output'}`, getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy=`${seeIn=='cantidad' ? 'qty_output' : 'pro_output'}`, getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false" v-if="tmpType=='all'">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtSalidas"
                                                    label="Salidas"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="number"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('salidas')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu> -->
                            </div>
                        </th>
                        <th class="text-right">
                            <div class="d-flex align-center">
                                <span>Stock final</span>
                                <!-- <div class="wrap-order" v-if="tmpType=='all'">
                                    <v-tooltip top>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-up"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='DESC', orderBy=`${seeIn=='cantidad' ? 'inv_current' : 'pro_current'}`, getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden descendente</span>
                                    </v-tooltip>
                                    <v-tooltip bottom>
                                        <template v-slot:activator="{ on, attrs }">
                                            <span class="order-down"
                                                v-bind="attrs"
                                                v-on="on"
                                                @click="orderType='ASC', orderBy=`${seeIn=='cantidad' ? 'inv_current' : 'pro_current'}`, getDataInventory()"
                                            ></span>
                                        </template>
                                        <span>Orden ascendente</span>
                                    </v-tooltip>
                                </div>
                                <v-menu offset-y :close-on-content-click="false" v-if="tmpType=='all'">
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-btn
                                        color="primary"
                                        dark
                                        icon
                                        small
                                        v-bind="attrs"
                                        v-on="on"
                                        >
                                            <v-icon>mdi-filter</v-icon>
                                        </v-btn>
                                    </template>
                                    <v-card>
                                        <v-card-text>
                                            <form @submit.prevent="processSearch">
                                                <v-text-field
                                                    v-model="txtStockFin"
                                                    label="Stock final"
                                                    outlined
                                                    dense
                                                    hide-details
                                                    type="number"
                                                ></v-text-field>
                                                <div class="text-right mt-4">
                                                    <v-btn
                                                        color="primary"
                                                        type="submit"
                                                        flat
                                                        small
                                                    >
                                                        <v-icon>mdi-magnify</v-icon>
                                                    </v-btn>
                                                    <v-btn
                                                        color="red"
                                                        text
                                                        small
                                                        @click="cleanSearch('stock_final')"
                                                    >
                                                        Limpiar
                                                    </v-btn>
                                                </div>
                                            </form>
                                        </v-card-text>
                                    </v-card>
                                </v-menu> -->
                            </div>
                        </th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item, index) in inventory" :key="index">
                        <td>
                            <v-btn
                                type="button"
                                color="warning"
                                x-small
                                @click="editSuply(item)"
                            >
                                <v-icon small>mdi-pencil</v-icon>
                            </v-btn>
                            <v-btn
                                type="button"
                                color="error"
                                x-small
                                @click="deleteSuply(item)"
                            >
                                <v-icon small>mdi-delete</v-icon>
                            </v-btn>
                        </td>
                        <td>{{ item?.code }}</td>
                        <td>{{ item?.name }}</td>
                        <td>
                            <span v-if="seeIn=='cantidad'">{{ item.unit_measure }}</span>
                            <span v-if="seeIn=='valorado'">{{ money }}</span>
                        </td>
                        <td class="text-right">
                            <span v-if="seeIn=='cantidad'">{{ formatNumber(item.info?.initial.quantity) }}</span>
                            <span v-if="seeIn=='valorado'">{{ formatNumber(item.info?.initial.value) }}</span>
                        </td>
                        <td class="text-right">
                            <span v-if="seeIn=='cantidad'">{{ formatNumber(item.info?.buys.quantity) }}</span>
                            <span v-if="seeIn=='valorado'">{{ formatNumber(item.info?.buys.value) }}</span>
                        </td>
                        <td class="text-right">
                            <span v-if="seeIn=='cantidad'">-{{ formatNumber(item.info?.outcome.quantity) }}</span>
                            <span v-if="seeIn=='valorado'">-{{ formatNumber(item.info?.outcome.value) }}</span>
                        </td>
                        <td class="text-right">
                            <span v-if="seeIn=='cantidad'">{{ formatNumber(item.info?.final.quantity) }}</span>
                            <span v-if="seeIn=='valorado'">{{ formatNumber(item.info?.final.value) }}</span>
                        </td>
                    </tr>
                </tbody>
                </template>
            </v-simple-table>
        </v-card>
        <div class="text-right py-2" v-html="pageTable" v-if="tmpType=='all'"></div>
        <v-pagination
            v-model="page"
            :length="totalPage"
            :total-visible="5"
            color="primary"
            @input="changePage"
            class="my-5"
            v-if="tmpType=='all'"
        ></v-pagination>
        <!-- end card main -->

        <!-- dialog -->
        <v-dialog
            v-model="dialogStock"
            max-width="800"
            scrollable
        >
            <v-card>
                <v-card-title>
                    Agregar stock
                </v-card-title>
                <v-card-text>

                    <v-card-title>
                        <v-text-field
                            v-model="search"
                            append-icon="mdi-magnify"
                            label="Buscar..."
                            outlined
                            dense
                            hide-details
                        ></v-text-field>
                    </v-card-title>

                    <div class="text-right blue-grey darken-4 white--text px-2 py-3 text-h5">
                        <strong>Total en {{ money }}</strong> {{ tmpTotal }}
                    </div>
                    <v-data-table
                        :headers="headers"
                        :items="listProduct"
                        :search="search"
                    >
                        <template v-slot:item.unit="{ item }">
                            {{ item.unit_measure }}
                        </template>
                        <template v-slot:item.quantity="{ item }">
                            <v-text-field
                                v-model="item.quantity"
                                type="number"
                                outlined
                                dense
                                min="0"
                                step="1"
                                hide-details
                                class="my-2"
                                @input="calculateTotal()"
                            ></v-text-field>
                        </template>
                        <template v-slot:item.cost="{ item }">
                            <v-text-field
                                v-model="item.cost"
                                type="number"
                                outlined
                                dense
                                min="0"
                                hide-details
                                class="my-2"
                                @input="calculateTotal()"
                            ></v-text-field>
                        </template>
                        <template v-slot:item.total="{ item }">
                            <span class="d-block text-right">{{ item.quantity * item.cost }}</span>
                        </template>
                    </v-data-table>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="error"
                        text
                        @click="dialogStock = false"
                    >Cancelar</v-btn>
                    <v-btn
                        color="primary"
                        @click="addStock"
                    >Guardar</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!-- END dialog -->

        <!-- dialog Add Suply -->
        <v-dialog
            v-model="dialogForm"
            max-width="800"

        >
            <v-card style="margin-bottom: -20px;">
                <v-form @submit.prevent="submitFormSuply" ref="refFormSuply" lazy-validation>
                    <v-card-title>
                        Agregar/Editar Insumo
                    </v-card-title>
                    <v-card-text>
                        <v-row style="margin-top: 20px;">
                            <v-col>
                                <v-text-field
                                    label="Código *"
                                    dense
                                    outlined
                                    :rules="[rules.required]"
                                    v-model="data.code"
                                    :error="(errors['code']) ? true : false"
                                    :error-messages="(errors['code']) ? errors['code'][0] : ''"
                                ></v-text-field>
                                <v-text-field
                                    label="Nombre *"
                                    dense
                                    outlined
                                    :rules="[rules.required]"
                                    v-model="data.name"
                                    :error="(errors['name']) ? true : false"
                                    :error-messages="(errors['name']) ? errors['name'][0] : ''"
                                ></v-text-field>
                                <v-select
                                    v-if="data.id === 0"
                                    :items="[
                                        { code: 'unidades', name: 'unidades' },
                                        { code: 'gramos', name: 'gramos' },
                                        { code: 'kilogramos', name: 'kilogramos' },
                                        { code: 'mililitros', name: 'mililitros' },
                                        { code: 'litros', name: 'litros' },
                                        { code: 'centimetros', name: 'centimetros' },
                                        { code: 'metros', name: 'metros' },
                                    ]"
                                    item-text="name"
                                    item-value="code"
                                    label="Unidad de medida"
                                    dense
                                    outlined
                                    v-model="data.measure"
                                    :rules="[
                                        v => !!v || 'Required',
                                    ]"
                                ></v-select>

                            </v-col>
                            <v-col>
                                <div v-if="data.id === 0">
                                    <v-text-field
                                        type="number"
                                        step="any"
                                        min="0"
                                        label="Cantidad (Opcional)"
                                        dense
                                        outlined
                                        v-model="data.quantity"
                                        :error="(errors['quantity']) ? true : false"
                                        :error-messages="(errors['quantity']) ? errors['quantity'][0] : ''"
                                    ></v-text-field>
                                    <v-text-field
                                        type="number"
                                        step="any"
                                        min="0"
                                        label="Costo Total (Opcional)"
                                        dense
                                        outlined
                                        v-model="data.cost"
                                        :error="(errors['cost']) ? true : false"
                                        :error-messages="(errors['cost']) ? errors['cost'][0] : ''"
                                    ></v-text-field>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-actions style="margin-bottom: 10px;">
                        <v-spacer></v-spacer>
                        <v-btn
                        color="error"
                        text
                        @click="dialogForm = false"
                        >Cancelar</v-btn>
                        <v-btn
                        color="primary"
                        type="submit"
                        >Guardar</v-btn>
                    </v-card-actions>
                </v-form>
            </v-card>
        </v-dialog>
        <!-- END dialog -->

        <!-- dialog suplies masive upload -->
        <v-dialog
            v-model="uploadSupliesDialog"
            max-width="800"

        >
            <v-card>
                <v-card-title>
                    Carga de Insumos
                </v-card-title>

                <v-card-text>
                    <v-row style="padding-bottom: 20px;">
                        <v-col style="border-right: 1px solid lightgray;">
                            <p><b>Archivo base (Datos en Excel):</b></p>
                            <a href="/carga_insumos.xlsx" target='_blank' >
                                <v-icon class="mr-2" color="green">mdi-file-table</v-icon>
                                Descargar
                            </a>
                            <p></p>

                            <p>Ejemplo: </p>
                            <div class="pb-3" style="max-width: 350px; overflow-x: scroll">
                                <table border="1" class="w-100" style="border-collapse: collapse;">
                                    <thead>
                                        <tr>
                                            <th class="px-2">codigo_insumo</th>
                                            <th class="px-2">nombre_insumo</th>
                                            <th class="px-2">unidad_medida</th>
                                            <th class="px-2">cantidad_opcional</th>
                                            <th class="px-2">costo_total_opcional</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr>
                                            <td class="px-2">TMT25</td>
                                            <td class="px-2">Tomate</td>
                                            <td class="px-2">kilogramos</td>
                                            <td class="px-2">5</td>
                                            <td class="px-2">70</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <div>
                                Unidades de medida:
                                <ul>
                                    <li>unidades</li>
                                    <li>gramos</li>
                                    <li>kilogramos</li>
                                    <li>mililitros</li>
                                    <li>litros</li>
                                    <li>centimetros</li>
                                    <li>metros</li>
                                </ul>

                            </div>

                        </v-col>
                        <v-col>
                            <v-form ref="refFormUploadSuplies">
                                <p>
                                    <b>Subir archivo Excel</b>
                                </p>
                                <v-file-input
                                    label="Archivo"
                                    accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
                                    :rules="[rules.required]"
                                    v-model="fileSuplies"
                                ></v-file-input>
                                <v-btn
                                    color="primary"
                                    @click="submitUploadSuplies"
                                >Subir</v-btn>
                            </v-form>
                        </v-col>
                    </v-row>

                </v-card-text>
            </v-card>
        </v-dialog>
        <!-- dialog suplies masive upload -->

        <!-- overlay -->
        <v-overlay :value="overlay" opacity=".9" z-index="10">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
        <!-- end overlay -->

    </v-container>
</template>
<script>
import axios from 'axios'

export default {
    data() {
        return {
            overlay: false,
            loading: false,
            breadcrumbs: [
                {
                    text: 'Productos',
                    disabled: false,
                    href: '/admin/products',
                },
                {
                    text: 'Inventario de Insumos',
                    disabled: true,
                    href: '',
                }
            ],
            // filter
            dateInit: '',
            dateEnd: '',
            menuInit: false,
            menuEnd: false,
            seeIn: 'cantidad',
            // data
            inventory: [],
            pageTable: '',
            page: 1,
            totalPage: null,
            // stock
            dialogStock: false,
            // tabla de insumos
            search: '',
            headers: [
                { text: 'Código', align: 'start', value: 'code' },
                { text: 'Insumo', align: 'start', value: 'name' },
                { text: 'Unidad de medida', value: 'unit' },
                { text: 'Cantidad', value: 'quantity' },
                { text: 'Costo total', value: 'cost' },
            ],
            listProduct: [],
            tmpTotal: 0,
            // form insumos
            dialogForm: false,
            uploadSupliesDialog: false,
            fileSuplies: null,
            // filters
            orderType: 'ASC',
            orderBy: 'created_at',
            CodeInsumo: '',
            txtInsumo: '',
            txtStockInit: '',
            txtCompras: '',
            txtSalidas: '',
            txtStockFin: '',
            txtMeasure: '',
            tmpType: 'all',
            data: {
                id: 0,
                code: '',
                name: '',
                measure: '',
                quantity: 0,
                cost: 0,
            },
            rules: {
                required: value => !!value || 'Campo obligatorio.',
                required2: value => value.length > 0 || 'Campo obligatorio.',
                size: value => !value || value.size < 7000000 || '¡El tamaño de la foto debe ser inferior a 2 MB!',
            },
            errors: {},
        }
    },
    props: ['slug', 'money'],
    mounted() {
        this.getDataInventory()
        this.getDataProducts()
    },
    methods: {
        calculateTotal() {
            this.tmpTotal = 0
            this.listProduct.forEach(item => {
                this.tmpTotal += parseFloat(item.cost);
            });
            this.tmpTotal = this.tmpTotal.toFixed(2)
        },
        /** sdfdsf */
        cleanSearch(type='') {
            if (type=='') {
                if ( (this.seeIn !== '') || (this.dateInit!='') || (this.dateEnd!='') ) {
                    this.dateInit = '';
                    this.dateEnd = '';
                    this.seeIn = 'cantidad';
                    this.page = 1;
                    this.getDataInventory()
                }
            } else {
                switch (type) {
                    case 'product':
                        this.txtInsumo = [];
                        this.CodeInsumo = "";
                        this.getDataInventory();
                        break;
                    case 'stock_init':
                        this.txtStockInit = ''
                        this.getDataInventory();
                        break;
                    case 'compras':
                        this.txtCompras = ''
                        this.getDataInventory();
                        break;
                    case 'salidas':
                        this.txtSalidas = ''
                        this.getDataInventory();
                        break;
                    case 'stock_final':
                        this.txtStockFin = ''
                        this.getDataInventory();
                        break;
                    case 'txtMeasure':
                        this.txtMeasure = '';
                        this.getDataInventory();
                    default:
                        break;
                }
            }
        },
        changePage(event) {
            this.page = event;
            this.getDataInventory();
        },
        processSearch() {
            this.page = 1
            this.getDataInventory()
        },
        /**
         * obtener datos del inventario
         */
        async getDataInventory() {
            this.overlay = true
            this.inventory = []
            await axios.get(`/admin/suplies/with_info?page=${this.page}
                            &orderby=${this.orderBy}
                            &ordertype=${this.orderType}
                            &date_init=${this.dateInit}
                            &date_end=${this.dateEnd}
                            &name=${this.txtInsumo}
                            &code=${this.CodeInsumo}
                            &unit_measure=${this.txtMeasure}
            `)
            .then((response) => {
                const resp = response.data
                this.inventory = resp.data
                this.pageTable = `Mostrando <strong>${resp.from??0} - ${resp.to??0}</strong> de un total de <strong>${resp.total}</strong>`
                this.totalPage = resp.last_page
                // this.tmpType = 'all'
                this.overlay = false
            })
            .catch((error) => {
                console.log(error)
                this.overlay = false
            })
        },

        /**
         * totales
         */
        sumaTotal(type) {
            let total = 0
            this.inventory.forEach(item => {
                total += (+item.info[type].value)
            })
            return total.toFixed(this.numberDecimals)
        },

        /**
         * stock
         */
        async getDataProducts() {
            this.overlay = true
            this.listProduct = []
            this.search = ''

            await axios.get(`/admin/suplies/with_info`)
            .then((response) => {
                // this.listProduct = response.data;
                response.data.forEach(ins => {
                    this.listProduct.push({
                        id: ins.id,
                        code: ins.code,
                        name: ins.name,
                        quantity: 0,
                        cost: 0,
                        unit_measure: ins.unit_measure
                    })
                });

                this.calculateTotal();
                this.overlay = false
            })
            .catch((error) => {
                console.log(error)
                this.overlay = false
            })
        },
        async addStock() {
            const tmpProds = this.listProduct.filter(ins => ins.quantity > 0)

            if (tmpProds.length > 0) {
                await axios.post('/admin/suplies/add-stock', {suplies: JSON.stringify(tmpProds)})
                .then((response) => {
                    // console.log(response)
                    if (response.data == 'ok') {
                        this.$notify.success('Se han guardado los cambios');
                        // this.getDataProducts()
                        this.getDataInventory()
                    }
                    this.dialogStock = false
                })
                .catch((error) => {
                    console.log(error)
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$notify.error('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                    }
                })
            } else {
                this.$notify.error('Por favor seleccione al menos un insumo');
            }
        },
        roundDecimals(num) {
            return (+num).toFixed(this.numberDecimals)
        },
        async submitFormSuply() {
            if (this.$refs.refFormSuply.validate()) {
                this.loading = true
                this.errors = {};

                let method = (this.data.id > 0)? 'put' : 'post';
                let suplies_url = (this.data.id > 0)? `/admin/suplies/${this.data.id}` : '/admin/suplies';

                await axios[method](suplies_url, {
                    code: this.data.code,
                    name: this.data.name,
                    unit_measure: this.data.measure,
                    quantity: this.data.quantity,
                    cost: this.data.cost
                }).then( response => {
                    this.$alert('', 'Insumo guardado con éxito.', 'success', {confirmButtonText: 'Continuar'})
                    this.getDataInventory()
                    this.getDataProducts()
                    this.$refs.refFormSuply.resetValidation()
                    this.dialogForm = false;
                    this.loading = false
                })
                .catch(error => {
                    console.log(error);

                    if (error.response.data.errors) {
                        this.errors = error.response.data.errors
                    }
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                    }
                    this.loading = false
                });

            }
        },
        newSuply() {
            this.errors = {};
            this.data.id = 0;
            if(this.$refs.refFormSuply) { this.$refs.refFormSuply.reset(); }
            this.dialogForm = true;
        },
        editSuply(item) {
            this.data = {
                id: item.id,
                code: item.code,
                name: item.name,
                measure: item.unit_measure,
                quantity: 0,
                cost: 0,
            };

            this.dialogForm = true;
        },
        deleteSuply(item) {
            this.$confirm(
                'Confirmar',
                '¿Eliminar insumo?',
                'info', {
                showCloseButton: true,
                reverseButtons: true,
                confirmButtonText: 'Continuar',
                cancelButtonText: 'Cancelar',
            }).then(res => {
                if (res) {
                    axios.delete(`/admin/suplies/${item.id}`)
                    .then(response => {
                        this.$alert('', 'Insumo eliminado con éxito.', 'success', {confirmButtonText: 'Continuar'})
                        // location.reload()
                        this.getDataInventory()
                        this.getDataProducts()
                    })
                    .catch(error => {
                        // console.log(error)
                        if (error.response.status == 404 || error.response.status == 500) {
                            this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                        }
                    })
                }
            });
        },
        async submitUploadSuplies() {
            if (this.$refs.refFormUploadSuplies.validate()) {
                let formData = new FormData();
                formData.append('file_suplies', this.fileSuplies);

                this.loading = true
                axios.post('/admin/suplies/upload', formData)
                .then(res => {
                    let { success } = res.data;
                    if(success) {
                        this.fileSuplies = null;
                        this.uploadSupliesDialog = false;
                        this.$notify.success('Se han guardado los cambios');
                        this.getDataInventory();
                        this.getDataProducts();
                    }
                }).catch(error => {
                    if (error.response.status == 404 || error.response.status == 500) {
                        this.$alert('Error con el servidor, por favor vuelva a intentarlo más tarde.');
                    }

                    if(error.response.status == 422) {
                        let errors = error.response.data.errors;
                        this.$fire({
                            html: errors.join('<br/>')
                        });
                    }
                }).finally(() => { this.loading = false; });

            }
        },
        formatNumber(n) {
            const formatoEuropeo = new Intl.NumberFormat('de-DE', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2,
            });
            return formatoEuropeo.format(n);
        }

    },
    computed: {
        numberDecimals () {
            return this.$store.state.numberDecimals.numberDecimals
        }
    },
}
</script>
